import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: "Abhishek Singh",
    title: "👋 Hey... I'am",
    desciption:"An Aspiring Full Stack Web Developer having an experience of building Web applications with JavaScript / Reactjs / Nodejs / MongoDb and some other cool libraries and frameworks.",
    image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    resumePdf: resume
}
